import Container from 'components/molecules/Container/Container';
import { appSwitchRoutes } from 'constants/routes';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader } from '@spotted-zebra-uk/ui-components';
import { CODING_ASSESSMENT_RETURN_URL_KEY } from 'views/RoleStageActions/flows/RoleStageCoderbyteAssessmentIntro';

/**
 * Fixed landing route Coderbyte returns every candidate to. They can only be
 * given one redirect URL per assessment, so the roles flow stashes the
 * in-flight stage's thank-you URL in localStorage before redirecting out, and
 * this page bounces back into it. Without one (e.g. storage cleared, or the
 * candidate finishing in a different browser) fall back to the roles list.
 */
const CodingAssessmentThankYou: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const returnUrl = localStorage.getItem(CODING_ASSESSMENT_RETURN_URL_KEY);
    if (returnUrl) {
      localStorage.removeItem(CODING_ASSESSMENT_RETURN_URL_KEY);
      navigate(returnUrl, { replace: true });
    } else {
      navigate(appSwitchRoutes.roles.getUrl(), { replace: true });
    }
  }, [navigate]);

  return (
    <Container className="page-loader-wrapper">
      <Loader variant="bubbles" />
    </Container>
  );
};

export default CodingAssessmentThankYou;
